$ = jQuery;
import { scroll } from "./scroll";
import Cookies from "js-cookie";
export const menu = {
  promoOpen: true,
  menuBusy: false,
  init: function () {
    let gsapmm = gsap.matchMedia();
    gsapmm.add("(min-width: 769px)", () => {
      gsap.from(".promotions-container", {
        opacity: 0.01,
        marginTop: 20,
        duration: 0.5,
        delay: 1,
      });
    });
    gsapmm.add("(max-width: 768px)", () => {
      $(".promotions-container").removeClass("opened");
      menu.promoOpen = false;
    });

    //Promotions
    gsap.from(".region-availability", {
      opacity: 0,
      marginTop: 20,
      duration: 1,
      stagger: 0.5,
      delay: 1,
    });
    $(".promo-link, .open-promo-mobile").on("click", function (e) {
      if (!menu.promoOpen) {
        //First click is to open panel
        e.preventDefault();
        menu.promoOpen = true;
        $(".promotions-container").addClass("opened");
      }
    });
    $(".close-promo").on("click", function (e) {
      //close promo panel
      e.preventDefault();
      menu.promoOpen = false;
      $(".promotions-container").removeClass("opened");
    });
    //Close promo panel if mouse is out after 3 seconds
    // let myTimeout = '';
    // $( ".promo-link" ).hover(
    //   function() {
    //     clearTimeout(myTimeout);
    //   }, function() {
    //     myTimeout = setTimeout(function(){
    //       if($('.promo-link:hover').length == 0) {
    //         menu.promoOpen = false;
    //         $('.promotions-container').removeClass('opened');
    //       }
    //     }, 3000)
    //   }
    // );

    //Language toggle
    $(".lang-switch-url").on("click", function () {
      $(".lang-switch-url").removeClass("selected");
      $(this).addClass("selected");
    });

    //Cookies to control the loader
    const urlQuery = new URLSearchParams(window.location.search);

    if (!Cookies.get("vicpark-loading")) {
      Cookies.set("vicpark-loading", 1, { expires: 1 / 24 });
      $("body").addClass("show-loading");
    }

    //Clone the quick links to append to the mega menu
    var quicklinks = $("<li class='cta-quick-links'></li>");
    $(".cta-quick-links").children().clone(true).appendTo(quicklinks);
    quicklinks.appendTo(".mega-menu-depth-1");

    //Make visible the first element of main menu
    $(".sub-level-menu:first").addClass("active");

    //Fill treatments on mobile menu
    $(".top-li-depth-0:first .main-menu-depth-1")
      .find("li")
      .each(function (i) {
        var treatment =
          $("body").attr("data-lang") == "en_US" ? "Treatment" : "Traitement";
        //$(this).prepend(`<span>${treatment} 0${i+1}</span>`);
      });
    //Fill treatments on desktop main menu
    $(".sub-level-menu:first")
      .find("li")
      .each(function (i) {
        var treatment =
          $("body").attr("data-lang") == "en_US" ? "Treatment" : "Traitement";
        //$(this).prepend(`<span>${treatment} 0${i+1}</span>`);
      });

    //Fill concerns on mobile menu
    $(".top-li-depth-0:nth-child(2) .main-menu-depth-1")
      .find("li")
      .each(function (i) {
        var condition =
          $("body").attr("data-lang") == "en_US" ? "Concern" : "Condition";
        //$(this).prepend(`<span>${condition} 0${i+1}</span>`);
      });
    //Fill concerns on desktop main menu
    $(".sub-level-menu:nth-child(2)")
      .find("li")
      .each(function (i) {
        var condition =
          $("body").attr("data-lang") == "en_US" ? "Concern" : "Condition";
        //$(this).prepend(`<span>${condition} 0${i+1}</span>`);
      });

    //Toggle the main-menu open
    $(".c-hamburger-mobile").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(".menu-item-has-children").removeClass("opened");
      $("header.header, body").removeClass("mega-menu-opened");
      $(".main-menu").addClass("ready");
      if ($(this).hasClass("is-active")) {
        $(this).removeClass("is-active");
        $("body").removeClass("mobile-menu-opened");
        if (typeof scroll.smoother.paused === "function") {
          scroll.smoother.paused(false);
        }
      } else {
        $(this).addClass("is-active");
        $("body").addClass("mobile-menu-opened");
        if (typeof scroll.smoother.paused === "function") {
          scroll.smoother.paused(true);
        }
      }
    });

    //Close the main menu
    $(".close-btn-menu").on("click", function (e) {
      e.preventDefault();
      $("body").removeClass("mobile-menu-opened");
      $(".c-hamburger-mobile").removeClass("is-active");
      if (typeof scroll.smoother.paused === "function") {
        scroll.smoother.paused(false);
      }
    });

    //Toggle the mega-menu open
    $("header.header nav ul.main-mega-menu > li.menu-item-has-children")
      .find("> a")
      .on("click", function (e) {
        var _this = this;
        e.preventDefault();
        e.stopPropagation();
        //Same menu opened
        if (
          $(this).parent().hasClass("opened") &&
          $("header.header").hasClass("mega-menu-opened") &&
          !menu.menuBusy
        ) {
          $(this).parent().removeClass("opened");
          $("header.header, body").removeClass("mega-menu-opened");
          if (typeof scroll.smoother.paused === "function") {
            scroll.smoother.paused(false);
          }
          menu.menuBusy = true;
          setTimeout(function () {
            menu.menuBusy = false;
          }, 1000);
          //All menus closed
        } else if (
          !$(this).parent().hasClass("opened") &&
          !$("header.header").hasClass("mega-menu-opened") &&
          !menu.menuBusy
        ) {
          $(this).parent().addClass("opened");
          $("header.header, body").addClass("mega-menu-opened");
          if (typeof scroll.smoother.paused === "function") {
            scroll.smoother.paused(true);
          }
          menu.menuBusy = true;
          setTimeout(function () {
            menu.menuBusy = false;
          }, 1000);
          //Other menu opened
        } else if (
          !$(this).parent().hasClass("opened") &&
          $("header.header").hasClass("mega-menu-opened") &&
          !menu.menuBusy
        ) {
          $(".menu-item-has-children").removeClass("opened");
          $(_this).parent().addClass("opened");
          menu.menuBusy = true;
          setTimeout(function () {
            menu.menuBusy = false;
          }, 1000);
        }
      });

    //Close menus when clicking outside;
    $(".site-content").on("click", function () {
      menu.closeAllMenus();
    });
    //Close menus when typing esc
    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        menu.closeAllMenus();
      }
    });

    //Responsive Main menu
    var mm = window.matchMedia("(max-width: 768px)");
    menuResponsive(mm);
    mm.addListener(menuResponsive);

    function menuResponsive(mm) {
      if (mm.matches) {
        $(".top-level-menu").find("li").removeClass("active");
        $(".top-li-depth-0").each(function () {
          var $ul = $(this).find("ul");
          var $li = $(this).find("ul li");
          var totalHeight = $li.length * 62 + 20;
          $ul.attr("style", `--this-height: ${totalHeight}px`);
          $(this).unbind("mouseenter mouseleave");
          if (!$(this).hasClass("target-self")) {
            $(this)
              .find("a:first")
              .on("click", function (e) {
                e.preventDefault();
              });
          }
          $(this)
            .find("ul")
            .find("a")
            .on("click", function (e) {
              e.stopPropagation();
            });
          $(this).on("click", function () {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
            } else {
              $(".top-li-depth-0").removeClass("active");
              $(this).addClass("active");
            }
          });
        });
      } else {
        $(".top-level-menu").find("li:first").addClass("active");
        $(".top-li-depth-0").each(function () {
          $(this).off("click");
          if (!$(this).hasClass("target-self")) {
            $(this)
              .find("a:first")
              .on("click", function (e) {
                e.preventDefault();
              });
          }
          $(this).hover(function () {
            $(".top-li").removeClass("active");
            const target = $(this).attr("data-target");
            $(this).addClass("active");
            $(".sub-level-menu").removeClass("active");
            $(`#${target}`).addClass("active");
          });
        });

        //Top header behavior on scroll
        var topHeader = gsap
          .timeline({ defaults: { ease: "none" } })
          .to("header.top", { y: 0 })
          .to("header.top", { y: -32 });

        ScrollTrigger.create({
          trigger: "header.top",
          start: "top 0",
          end: "+=80",
          animation: topHeader,
          scrub: true,
        });

        //Header behavior on scroll
        var topHeader = gsap
          .timeline({ defaults: { ease: "none" } })
          .to("header.header", { y: 0 })
          .to("header.header", { y: -32 });
        ScrollTrigger.create({
          trigger: "header.top",
          start: "top 0",
          end: "+=80",
          animation: topHeader,
          scrub: true,
        });
      }
    }
  },
  closeAllMenus: function () {
    $("body").removeClass("has-popup-banner");
    if ($("body").hasClass("mega-menu-opened")) {
      $("header.header, body").removeClass("mega-menu-opened");
      $(".menu-item").removeClass("opened");
    }
    if ($("body").hasClass("mobile-menu-opened")) {
      $("body").removeClass("mobile-menu-opened");
      $(".c-hamburger-mobile").removeClass("is-active");
    }
    if (typeof scroll.smoother.paused === "function") {
      scroll.smoother.paused(false);
    }
  },
};
